import '../scss/app.scss';
import {gsap} from "gsap";
import {initHeader} from "./components/header";
import lozad from "lozad";
import tippy from 'tippy.js';
import {initMainSlider} from "./components/main-slider";
import {initLoadmore} from "./components/loadmore";
import {initSmoothScroll} from "./components/animation";
import {initAboutSlider} from "./components/about-slider";
import {initGallerySlider} from "./components/gallery-slider";
import {initMainMatchesSliders} from "./components/main-matches-slider";
import {initMainPlayersSliders} from "./components/main-players-slider";
import {initMainSliderWithoutMatches} from "./components/main-slider-without-matches"
import {initTournamentSlider} from "./components/tournament-slider";
import {initSelects} from './components/selects';
import {initMainVideoSlider} from "./components/video-slider"
import {initMainPhotoSlider} from "./components/photo-slider"
import {initTournamentTable} from './components/tournament-table';
import {initTabs} from "./components/helpers"

function loadSite() {

        document.body.style.overflow = 'hidden';
        document.querySelector('.preloader-modal .logo-transparent').style.height = '90px';

    const intervalId = setInterval(function() {
        if(document.readyState == 'loading'){

                document.querySelector('.preloader-modal .logo-transparent').style.height = '130px';

        }
        if(document.readyState == 'interactive'){

                document.querySelector('.preloader-modal .logo-transparent').style.height = '160px';

        }
        if (document.readyState == 'complete') {
            clearInterval(intervalId); // остановка интервала
            document.querySelector('.preloader-modal .logo-container .logo-transparent').style.height = '240px';

            setTimeout(function (){
                closeModal();
            },1000)

        }
    }, 30);
}

// loadSite();
let firstTimeLoad = true;

function closeModal() {
    document.querySelector('.preloader-modal').style.opacity = '0';
    document.querySelector('.preloader-modal .logo-transparent').style.opacity = '0';
    document.querySelector('.preloader-modal .logo').style.opacity = '0';
    document.body.style.overflow = 'auto';
    // firstTimeLoad = true;
    setTimeout(function (){
        document.querySelector('.preloader-modal').style.display = 'none';
    },1000)

}
$(document).ready(function () {

    const observer = lozad('.lozad', {
        load: function (image) {
            if (window.innerWidth < 1000) {
                if (image.dataset.mobileBackground) {
                    $(image).css('background-image', 'url(' + image.dataset.mobileBackground + ')');
                } else {
                    $(image).css('background-image', 'url(' + image.dataset.background + ')');
                }
            } else {
                $(image).css('background-image', 'url(' + image.dataset.background + ')');
            }

            if (image.dataset.src) {
                image.src = image.dataset.src;
            }

            image.classList.add('fade');
        }
    });

    observer.observe();

    // инициализация компонентов
    initHeader();
    initMainSlider();
    initMainSliderWithoutMatches();
    initLoadmore(observer);
    initSmoothScroll();
    const $aboutSlider = initAboutSlider();
    const $tournamentSlider = initTournamentSlider();
    initGallerySlider();
    initSelects();
    initTournamentTable();
    initMainMatchesSliders();
    initMainPlayersSliders();
    initMainVideoSlider();
    initMainPhotoSlider();
    /*initGsap();*/

    //Костыль для браузеров сафари на айфоне и андроиде с эджем
    const isSafariOniPhone = navigator.userAgent.match(/i(Phone|Pod|Pad).+Safari/);
    const isEdgeOnAndroid = navigator.userAgent.match(/Android.*Edg/);
    let prevHeight = $(window).height();
    const flatInfoMain = $('.main-screen').find('.flat-info');
    const mainScreen = $('.main-screen');
    if (isSafariOniPhone || isEdgeOnAndroid) {
        // mainScreen.css('height','100vh'); // установите желаемое значение
    }

/*    let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    $(window).on('resize', function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    })*/

    $('.play').on('click', function (){
        const $frame = $(this).parent().find('iframe')
        if($frame.length !== 0){
            $frame.removeClass('hide').addClass('frameclass')
            $(this).addClass('hide')
        }
    })

    $('.img-block-wrapper .image').on('mouseenter',function (){
        const $imgBlock = $(this).parents('.img-block');
        const $parent = $imgBlock.parent();
        const $index = $imgBlock.index() + 1;

        $parent.addClass('hover-' + $index)
    }).on('mouseleave',function (){
        const $imgBlock = $(this).parents('.img-block');
        const $parent = $imgBlock.parent();
        const $index = $imgBlock.index() + 1;

        $parent.removeClass('hover-' + $index)
    })

    const initInterval = setInterval(function (){
        if(firstTimeLoad === true){
            moveLine();
            clearInterval(initInterval);
        }
    }, 100)


    function moveLine(){
        $('[data-line]').each(function (index,element){
            const $padding = $('.container').css('padding-left')
            const number = $(element).data('line');
            let newLeft = $('[data-tab=' + number + ']')[0].offsetLeft - parseInt($padding);

            $(element).css('left', newLeft);
        })
    }

    // вкладки
    if ($('[data-tabs-block]').length) {
        $('[data-tabs-block]').each(function() {
            initTabs($(this));
        })
    }

    function changeSlide(swiper, number){
         // Переключаем на указанный слайд
        swiper.slideTo(number - 1);
    }

    $('[data-anchor], [data-tab]').on('click', function() {
        const $this = $(this);
        let $tabItem = '';
        const number = $this.data('anchor') || $this.data('tab');
        if(!$this.data('tab')){
            $tabItem = $('[data-tab='+ number +']')
        }
        let $tab = '';
        let $slider = '';
        if($this.data('anchor')){
            $tab = '.matches';
            $slider = $tournamentSlider;
            $('html, body').animate({
                scrollTop: $('.tabs.matches').offset().top
            }, 100);
            if($tabItem.hasClass('active')) return;
            const $activeLine = $($tab + ' [data-line].active');
            const currentLine = $activeLine.data('line');
            $tabItem.addClass('active').siblings().removeClass('active');
            $($tab + ' [data-line='+ number +']').data('line', currentLine);
            $($tab + ' [data-line='+ number +']').attr('data-line', currentLine);
            $activeLine.data('line', number);
            $activeLine.attr('data-line', number);
            moveLine();
        } else {
            if($this.parents('.tabs').hasClass('about')){
                $tab = '.about';
                $slider = $aboutSlider;
            } else if($this.parents('.tabs').hasClass('matches')){
                $tab = '.matches';
                $slider = $tournamentSlider;
            }
            if($this.hasClass('active')) return;
            const $activeLine = $($tab + ' [data-line].active');
            const currentLine = $activeLine.data('line');
            $this.addClass('active').siblings().removeClass('active');
            $($tab + ' [data-line='+ number +']').data('line', currentLine);
            $($tab + ' [data-line='+ number +']').attr('data-line', currentLine);
            $activeLine.data('line', number);
            $activeLine.attr('data-line', number);
            moveLine();
        }
        changeSlide($slider, number);
    });

    $(window).on('resize', function (){
        moveLine();
    })

    //scroll to
    $('.nav-link').on('click', function(e) {
        // Get the ID of the target element
        let targetId = $(this).attr('href');

        // If the target element has an ID, scroll to it
        if (targetId.indexOf('#') === 0) {
            $('html, body').animate({
                scrollTop: $(targetId).offset().top
            }, 400);
        }

        // Check if the target element is a link
        if ($(targetId).is('a')) {
            // Follow the link
            window.location.href = targetId;
        }

        // Prevent the default action
        e.preventDefault();

        // If the screen width is less than 1000, remove the menu-block-open class from HTML
        if ($(window).width() < 1000) {
            $('html').removeClass('menu-block-open');
        }
    });

    tippy('.club-link.volleyball', {
        content: "Волейбол",
    });

    tippy('.club-link.football', {
        content: "Футбол",
    });

    tippy('.club-link.hockey', {
        content: "Хоккей",
    });
})
